/**
 * Lecture d'une réponse HTTP attendue en JSON, avec un message exploitable.
 *
 * ⚠️ RAISON D'ÊTRE — le mode d'échec observé en production le 2026-08-07 n'est
 *    PAS un code d'erreur : c'est un `200 text/html`.
 *
 *    Les pages d'administration sont servies sur les DEUX hôtes, mais la
 *    surface API d'administration n'est routée que sur `admin.…`
 *    (docker-compose.prod.yml:185 — barrière topologique délibérée). Sur
 *    l'hôte public, Traefik ne reconnaît pas ces chemins, retombe sur le
 *    routeur frontend, et nginx répond par le repli SPA : `index.html`,
 *    en 200.
 *
 *    Un contrôle de `res.ok` ne voit RIEN — 200 est un succès. C'est
 *    `res.json()` qui casse, sur un message que l'utilisateur ne peut pas
 *    relier à sa cause :
 *
 *        SyntaxError: Unexpected token '<', "<!DOCTYPE "... is not valid JSON
 *
 *    D'où le contrôle du TYPE DE CONTENU, et pas seulement du statut.
 */

/** L'hôte courant sert-il l'interface sans servir l'API d'administration ? */
function repliSpaProbable(res) {
  const type = res.headers.get("content-type") || "";
  return type.includes("text/html");
}

/**
 * Message d'erreur destiné à l'écran, pas à la console.
 * Nomme la cause quand elle est identifiable, sinon reste factuel.
 */
export function messageErreurHttp(res, url = "") {
  const chemin = url || res.url || "";

  if (repliSpaProbable(res)) {
    return (
      `Cette API n'est pas disponible sur « ${window.location.host} » : le ` +
      `serveur a renvoyé la page du site au lieu de données (HTTP ${res.status}). ` +
      `Les surfaces d'administration ne sont routées que sur l'hôte ` +
      `d'administration.`
    );
  }

  if (res.status === 401) return "Session expirée ou absente — reconnecte-toi.";
  if (res.status === 403) return "Accès refusé : ce compte n'est pas administrateur.";
  if (res.status === 404) return `Route inconnue du serveur (404) : ${chemin}`;
  if (res.status === 405) {
    return (
      `Méthode refusée (405) sur ${chemin} — la requête n'a pas atteint ` +
      `l'application. Vérifie l'hôte utilisé.`
    );
  }
  if (res.status >= 500) return `Erreur serveur ${res.status} sur ${chemin}.`;
  return `Erreur HTTP ${res.status} sur ${chemin}.`;
}

/**
 * Lit une réponse en JSON ou lève une erreur porteuse de sens.
 * L'erreur expose `status` et `reponse` pour l'appelant qui veut décider.
 */
export async function lireJson(res, url = "") {
  if (!res.ok || repliSpaProbable(res)) {
    const err = new Error(messageErreurHttp(res, url));
    err.status = res.status;
    err.reponse = res;
    throw err;
  }
  return res.json();
}
